module.exports = __webpack_public_path__ + "static/lifestyle-3c7cb4872920ab83cf0e5265cebea8f8.svg";